import { render, staticRenderFns } from "./TrainPadClick.vue?vue&type=template&id=05a00ba9&scoped=true&"
import script from "./TrainPadClick.vue?vue&type=script&lang=js&"
export * from "./TrainPadClick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a00ba9",
  null
  
)

export default component.exports